import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Form from '@/components/base/Form'
import Grid from '@/components/base/Grid'
import Typography from '@/components/base/Typography'

import Logo from '../base/Logo'
import { cn } from '@/lib/utils'
import { WPGravityForm } from '@/types'

export type ContactFormProps = HTMLAttributes<HTMLElement> &
  Partial<{
    intro: string
    overline: string
    title: string
    subtitle: string
    form: WPGravityForm
  }>

const ContactForm = ({
  intro,
  overline,
  title,
  subtitle,
  form,
  className,
  ...props
}: ContactFormProps) => {
  return (
    <section className={cn('min-h-lvh-vh relative flex w-full py-[10rem]', className)} {...props}>
      <Container className="my-auto">
        <Grid className="items-center gap-y-spacing-md">
          <div className="col-span-4 md:col-span-4 md:col-start-2 lg:col-span-4 lg:col-start-2">
            <div className="grid gap-y-spacing-sm">
              <div className="flex">
                <span className="sr-only">{title}</span>
                <Logo className="h-[3.5rem] w-[14rem]" />
              </div>
              <div className="grid gap-y-spacing-xs">
                <Typography variant="regular" component="h2" className="text-text-secondary-dark">
                  {intro}
                </Typography>
                <Typography variant="h6" component="h3" className="">
                  {overline}
                </Typography>
              </div>
              <div className="flex">
                <Typography variant="regular" paragraph className="text-text-secondary-dark">
                  {subtitle}
                </Typography>
              </div>
            </div>
          </div>
          <div className="col-span-4 md:col-span-4 md:col-start-2 lg:col-span-5 lg:col-start-7">
            <Form
              form_id={form?.id?.toString()}
              fields={form?.fields}
              submit={form?.button?.text}
            />
          </div>
        </Grid>
      </Container>
    </section>
  )
}

export default ContactForm
